import {useResumeRequestResponse} from '@aboutyou/user';
import {useEffect, useRef} from 'react';
import {MAX_TIMEOUT_WAIT_IN_MS} from '../../../constants/constants';

export const useRefetchIsCustomerSessionValidNextUpdate = () => {
  const {data, refetch} = useResumeRequestResponse();
  const now = new Date().getTime();
  const timeout = useRef<NodeJS.Timeout>(undefined);
  const nextUpdate = data?.nextResumeAt
    ? data.nextResumeAt.getTime()
    : undefined;

  useEffect(() => {
    if (!nextUpdate) {
      return;
    }

    const diff = nextUpdate - now;

    timeout.current = setTimeout(() => {
      refetch();
    }, Math.min(diff, MAX_TIMEOUT_WAIT_IN_MS));

    return () => timeout.current && clearTimeout(timeout.current);
  }, [nextUpdate]);
};
